import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { bindActionCreators } from 'redux'

import * as UserSelectors from 'modules/user/selectors'

import VerifyEmailError from './component'

const mapStateToProps = (state) => ({
  email: UserSelectors.getEmail(state),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      push,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onRedirectToLogin: (props) => () => {
      props.actions.push('/start')
    },
  })
)(VerifyEmailError)
